enum StatementStatusCode {
  OPEN = 'OPEN',
  APPROVED = 'APPROVED',
  RECONCILED = 'RECONCILED',
  CANCELED = 'CANCELED',
  PRELIMINARY = 'PRELIMINARY',
}

export default StatementStatusCode;
export type VerifyStatementStatusCode = Utils.VerifyExtends<
  Model.Enum.StatementStatusCode,
  Utils.ValueOf<typeof StatementStatusCode>
>;
